import { Component } from "react"
import PropTypes from "prop-types"

import AccountInfo from "./account_info"

export default class MyServiceSettingsView extends Component {
  render() {
    return (
      <>
        <div className="service-settings-view">
          <AccountInfo {...this.props} />
        </div>
      </>
    )
  }
}

MyServiceSettingsView.propTypes = {
  service: PropTypes.object.isRequired,
  liveChannels: PropTypes.array.isRequired,
  addAccountPath: PropTypes.string.isRequired,
  allowMultipleLiveChannels: PropTypes.bool,
}

MyServiceSettingsView.defaultProps = {
  allowMultipleLiveChannels: false,
}
